/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.996
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveFinalInterview,
	getFinalInterviewCreateInit,
	getFinalInterviewEditInit,
	getFinalInterviewView,
	deleteFinalInterview
} from '@api/lcf/FinalInterview';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinalInterviewCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinalInterviewCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinalInterviewEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinalInterviewEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinalInterview({}, FinalInterview) {
			return new Promise((resolve, reject) => {
				saveFinalInterview(FinalInterview)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinalInterviewView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinalInterviewView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinalInterview({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinalInterview({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
